import { render, staticRenderFns } from "./CalcStepWind.vue?vue&type=template&id=36c7aa2d&scoped=true&"
import script from "./CalcStepWind.vue?vue&type=script&lang=js&"
export * from "./CalcStepWind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7aa2d",
  null
  
)

export default component.exports